import { motion } from "framer-motion";

const facts = [
  { n: "25+", l: "Years of experience" },
  { n: "4,000+", l: "Dogs trained" },
  { n: "3rd", l: "Generation trainer" },
  { n: "1", l: "Wolfkeeper University" },
  { n: "1", l: "Golden Wolf Foundation" },
];

const credentials = [
  "Founder — Wolfkeeper University",
  "Founder — Golden Wolf Foundation",
  "B.A. Speech Communications & Marketing",
  "International training experience",
  "Entertainment · Marketing · Logistics · Product · Technology",
];

export default function Credibility() {
  return (
    <section className="section relative" data-testid="credibility-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-14">
          <div className="md:col-span-4">
            <div className="text-eyebrow text-gold">03 / Results & Credibility</div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-[clamp(2.2rem,5.4vw,5.4rem)] leading-[0.95] tracking-[-0.02em]">
              A resume written in <span className="italic gold-foil">outcomes.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-4 border-y border-hair py-10 mb-12">
          {facts.map((f) => (
            <motion.div
              key={f.l}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              data-testid={`cred-fact-${f.l.replace(/\s+/g, '-').toLowerCase()}`}
            >
              <div className="stat-num text-4xl md:text-5xl text-bone">{f.n}</div>
              <div className="text-hair text-bone/50 mt-2">{f.l}</div>
            </motion.div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-3">
          {credentials.map((c, i) => (
            <motion.div
              key={c}
              initial={{ opacity: 0, x: -10 }}
              whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.05 * i }}
              className="flex items-center gap-4 border-b border-hair pb-3"
            >
              <span className="text-gold">✦</span>
              <span className="text-bone/80">{c}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
